import React from "react";

const About = () => {
  return (
    <div>
      <h2 className="text-3xl text-violet-900 font-bold my-7">About us</h2>
    </div>
  );
};

export default About;
